const popup = () => {
  const pop = document.querySelector(".js-popup");
  const popBg = document.querySelector(".js-popup-bg");
  const popClose = document.querySelector(".js-popup-close");
  if (!pop) return;

  popBg.addEventListener("click", () => {
    pop.classList.add("hide");
  });
  popClose.addEventListener("click", () => {
    pop.classList.add("hide");
  });
  //   setTimeout(() => {
  //     pop.classList.add("hide");
  //   }, 5000);
};

export default popup;
